import type { SyncTransportResult } from "../sync/types";
import type { SourceChannel } from "./events";

export const DOMAIN_COMMAND_STATUSES = [
  "applied",
  "replayed",
  "terminal_conflict",
  "rejected",
] as const;

export type DomainCommandStatus = (typeof DOMAIN_COMMAND_STATUSES)[number];

export interface DomainCommandEnvelope<
  TPayload extends Readonly<Record<string, unknown>> = Readonly<Record<string, unknown>>,
> {
  operationId: string;
  commandType: string;
  commandVersion: number;
  farmId: string;
  deviceId: string;
  sourceChannel: Exclude<SourceChannel, "system" | "migration">;
  performedAt: string;
  baseVersion: number;
  payload: TPayload;
}

export interface DomainCommandResult {
  status: DomainCommandStatus;
  operationId: string;
  aggregateType: string;
  aggregateId: string;
  aggregateVersion?: number;
  eventId?: string;
  errorCode?: string;
  result: Readonly<Record<string, unknown>>;
}

export function commandResultToSyncResult(result: DomainCommandResult): SyncTransportResult {
  if (result.status === "applied" || result.status === "replayed") {
    return {
      kind: "applied",
      serverResult: {
        ...result.result,
        status: result.status,
        aggregateType: result.aggregateType,
        aggregateId: result.aggregateId,
        ...(result.aggregateVersion === undefined
          ? {}
          : { aggregateVersion: result.aggregateVersion }),
        ...(result.eventId === undefined ? {} : { eventId: result.eventId }),
      },
    };
  }

  return {
    kind: "terminal_conflict",
    code:
      result.errorCode ?? (result.status === "rejected" ? "COMMAND_REJECTED" : "DOMAIN_CONFLICT"),
    details: {
      ...result.result,
      status: result.status,
    },
  };
}
